var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "app-browse",
        {
          attrs: {
            "data-source": _vm.dataSource,
            "selected-items": _vm.selectedItems,
            "controls-disabled": _vm.controlsDisabled,
            "is-search-only": _vm.isSearchOnly,
            "search-enabled": _vm.searchEnabled,
            "button-bar-items": _vm.buttonBarItems,
            "url-query-params": "",
          },
          on: {
            "search-item-selected": function ($event) {
              return _vm.onSearchItemSelected($event)
            },
            "open-client-portal": function ($event) {
              return _vm.openClientPortal()
            },
            "open-client-portal-modal": function ($event) {
              return _vm.openClientPortalModal()
            },
            "open-import-csv-modal": function ($event) {
              return _vm.openImportCsvModal()
            },
            "open-history-of-client-in-sales": function ($event) {
              return _vm.openHistoryOfClientSales()
            },
            "open-history-of-client-in-sale-detail": function ($event) {
              return _vm.openHistoryOfClientSaleDetail()
            },
            "open-history-of-client-in-bank": function ($event) {
              return _vm.openHistoryOfClientBank()
            },
            "new-document": function ($event) {
              return _vm.newDocument()
            },
            "col-click-result": _vm.onColClick,
            state: function ($event) {
              _vm.browseState = $event
            },
          },
        },
        [
          _vm._t("header", null, { slot: "header" }),
          _vm._t("extra-buttons", null, { slot: "extra-buttons" }),
          _vm._t("more", null, { slot: "more" }),
          _vm._t("top", null, { slot: "top" }),
          _vm._t("bottom", null, { slot: "bottom" }),
        ],
        2
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.uploadCSVModal,
            callback: function ($$v) {
              _vm.uploadCSVModal = $$v
            },
            expression: "uploadCSVModal",
          },
        },
        [
          _c("app-import-csv-modal", {
            attrs: { "group-id": _vm.browseId },
            on: {
              close: function ($event) {
                _vm.uploadCSVModal = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.clientPortalUrl != "" } },
        [
          _vm.canCreateClientPortal
            ? _c("app-portal-send-modal", {
                attrs: {
                  link: _vm.clientPortalUrl,
                  contact: _vm.selectedItems[0],
                },
                on: {
                  cancel: function ($event) {
                    _vm.clientPortalUrl = ""
                  },
                },
              })
            : _c("app-missing-module-modal", {
                attrs: { "module-id": 83 },
                on: {
                  close: function ($event) {
                    _vm.clientPortalUrl = ""
                  },
                },
              }),
        ],
        1
      ),
      _vm.selectedContact != null
        ? _c(
            "w-modal",
            { attrs: { value: _vm.historyOfClientBrowse != "" } },
            [
              _c(
                "w-card",
                [
                  _c(
                    "w-card-title",
                    [
                      _vm._v(_vm._s(_vm.historyOfClientTitle)),
                      _c("w-spacer"),
                      _c(
                        "w-link",
                        {
                          attrs: { white: "" },
                          on: {
                            click: function ($event) {
                              _vm.historyOfClientBrowse = ""
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "times" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.historyOfClientBrowse == "sales"
                    ? _c(
                        "app-sale-search-browse",
                        {
                          attrs: {
                            "book-year-select": true,
                            "contact-id": _vm.selectedContact.ID,
                            "browse-id": 6,
                            multiple: false,
                            "exclude-saldos": "",
                          },
                          on: {
                            select: function ($event) {
                              return _vm.onSelectionChange($event)
                            },
                          },
                        },
                        [
                          _vm._t(
                            "extra-buttons",
                            function () {
                              return [
                                _c(
                                  "w-button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.$ct("view-document"),
                                        expression: "$ct('view-document')",
                                      },
                                    ],
                                    attrs: {
                                      disabled: _vm.selectedSale == null,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openDocument()
                                      },
                                    },
                                  },
                                  [
                                    _c("w-fa", {
                                      staticClass: "no-margin",
                                      attrs: { icon: "eye" },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            { slot: "extra-buttons" }
                          ),
                        ],
                        2
                      )
                    : _vm.historyOfClientBrowse == "sale-rows"
                    ? _c("app-sale-detail-browse", {
                        attrs: {
                          "book-year-select": true,
                          "contact-id": _vm.selectedContact.ID,
                          "browse-id": 7,
                          "exclude-saldos": "",
                        },
                      })
                    : _vm.historyOfClientBrowse == "bank"
                    ? _c("app-bank-search-browse", {
                        attrs: {
                          "book-year-select": true,
                          "contact-id": _vm.selectedContact.ID,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-modal",
        {
          staticClass: "w100",
          attrs: {
            value: _vm.$route.path != _vm.baseRoutePath,
            "full-height": "",
          },
        },
        [
          _c("router-view", {
            key: _vm.$route.path,
            on: {
              saved: function ($event) {
                return _vm.updateView()
              },
              close: function ($event) {
                return _vm.$router.push(_vm.baseRoutePath)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.sendMessageDialogContact != null } },
        [
          _vm.sendMessageDialogContact
            ? _c("app-send-message-dialog", {
                attrs: {
                  "additional-bcc": _vm.sendMessageDialogContact
                    .getAdditionalBccEmails()
                    .join(";"),
                  to: _vm.sendMessageDialogContact.getDefaultEmail(),
                },
                on: {
                  close: function ($event) {
                    return _vm.closeSendMessageDialog()
                  },
                  sent: function ($event) {
                    return _vm.closeSendMessageDialog()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.excelMapperOpen
        ? _c("app-excel-mapper", {
            attrs: { service: _vm.contactService },
            on: {
              close: function ($event) {
                _vm.excelMapperOpen = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }